<div class="aig-historyPolicy u-my-8 container u-minheight-vh-60">
  <div class="row u-justify-center">
    <div class="col-12">
      <aig-breadcrumb
        [config]="[
          { title: 'Inicio', link: '/area-cliente' },
          {
            title: 'Historial de pólizas',
            link: '/area-cliente/historial-polizas'
          }
        ]"
      >
      </aig-breadcrumb>
    </div>

    <div class="col-12 col-md-6 u-mt-8">
      <section>
        <div class="u-ds-grid u-gap-40">
          <!-- Title -->
          <h1 class="u-color-primary1 u-fw-400 u-h1 u-text-center">
            Detalles de póliza
          </h1>

          <div
            class="u-radius-4 u-border u-border-comp3 u-px-8 u-py-6 u-ds-grid u-gap-16"
          >
            <h2 class="u-color-primary1 u-fw-500 u-h2">Datos de la póliza</h2>

            <div class="u-fs-18 u-fw-600 u-color-secondary1 p-flexcb">
              <p class="u-fw-400">Número de póliza</p>
              {{ policy?.num_Poliza }}
            </div>

            <div class="u-fs-18 u-fw-400 u-color-secondary1 p-flexcb">
              <p class="u-fw-400">Estado de la póliza</p>
              <p class="e-badge" [ngClass]="policyState(policy?.idEstado)">
                {{ policy?.estado_Poliza }}
              </p>
            </div>

            <div class="u-fs-18 u-fw-400 u-color-secondary1 p-flexcb">
              <p>Fecha de inicio de cobertura</p>
              {{
                policy?.fecha_Inicio_Cobertura
                  | date : "dd-MM-yyyy" : "No disponible"
              }}
            </div>

            <div class="u-fs-18 u-fw-400 u-color-secondary1 p-flexcb">
              <p>Fecha fin de cobertura</p>
              {{
                policy?.fecha_Fin_Cobertura
                  | date : "dd-MM-yyyy" : "No disponible"
              }}
            </div>

            <div class="u-fs-18 u-fw-400 u-color-secondary1 p-flexcs">
              <button
                class="e-btn--link u-fw-600 u-fs-16 u-ms-0 u-ps-0"
                type="button"
                (click)="download()"
              >
                Ver póliza contratada
              </button>
            </div>
          </div>

          <div class="u-radius-4 u-border u-border-comp3 u-px-8">
            <div class="p-flexcb u-p-3 u-border-bottom u-border-primary2">
              <p class="u-fs-18 u-fw-400 u-color-secondary1">
                Modificar datos de la póliza
              </p>
              <button
                class="e-btn--primary u-cursor-pointer"
                (click)="goToModifyPolicy()"
              >
                Acceder
              </button>
            </div>
            <div class="p-flexcb u-p-3 u-border-bottom u-border-primary2">
              <p class="u-fs-18 u-fw-400 u-color-secondary1">
                Gestión de siniestros
              </p>
              <button
                class="e-btn--secondary u-cursor-pointer"
                (click)="goToClaimsManagement()"
              >
                Acceder
              </button>
            </div>
            <div class="p-flexcb u-p-3" *ngIf="policy?.idEstado == 1">
              <p class="u-fs-18 u-fw-400 u-color-secondary1">
                Dar de baja mi póliza de ciberseguridad
              </p>
              <button
                class="e-btn--secondary u-cursor-pointer"
                (click)="cancelModalVisible = true"
                [disabled]="policy?.idEstado != 1"
              >
                Solicitar
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
@if (cancelModalVisible == true) { @if (alreadyCancelled == true) { MODAL CON
MENSAJE DE QUE YA SE HA TRAMITADO LA CANCELACIÓN
<aig-modal-already-cancelled
  (hideModal)="cancelModalVisible = false"
></aig-modal-already-cancelled>

} @else {
<!-- MODAL CON FLUJO PARA CANCELAR -->
<aig-modal-cancel-policy
  [policyResponse]="policy"
  [IdPoliza]="IdPoliza"
  (hideModal)="onCloseModalCancelation($event)"
></aig-modal-cancel-policy>
} } @if(visibleNewClaimModal){
<aig-modal-new-claim
  (hideNewClaimModal)="CloseNewClaim()"
></aig-modal-new-claim>
}

<aig-modal-rejected
  *ngIf="rejectedClaimModalVisible"
  [existenSiniestros]="resultado?.existenSiniestros ?? null"
  (hideModal)="onCloseModalRejectedClaim()"
></aig-modal-rejected>
